import { render, staticRenderFns } from "./yazy.vue?vue&type=template&id=75883986&scoped=true&"
import script from "./yazy.vue?vue&type=script&lang=js&"
export * from "./yazy.vue?vue&type=script&lang=js&"
import style0 from "./yazy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./yazy.vue?vue&type=style&index=1&id=75883986&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75883986",
  null
  
)

export default component.exports